import { FieldTemplate } from 'api/models';
import { LayoutItem, LayoutItemType } from 'api/models/FormTemplate';
import { getId } from 'utils';

export function getReportTemplateLayout(fieldTemplateId: string) {
  return {
    id: getId(),
    type: LayoutItemType.Input,
    layoutOptions: {
      layout: '12',
    },
    fieldTemplateId,
  } as LayoutItem;
}

export function getReportTemplateFieldTemplate(alias: string) {
  const fieldTemplateId = getId();
  return {
    _id: fieldTemplateId,
    alias,
    fieldAttributes: {
      label: 'report code',
      code: '',
    },
    id: fieldTemplateId,
    fieldType: 'report',
    formFieldTemplateId: getId(),
    version: 1,
  } as FieldTemplate;
}
